import { render, staticRenderFns } from "./PendingPage.vue?vue&type=template&id=1bc67bb2&"
import script from "./PendingPage.vue?vue&type=script&lang=js&"
export * from "./PendingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports